import { Button, Checkbox, Col, DatePicker, Form, Input, InputNumber, Pagination, Radio, Row, Select, Space, Table, Tabs } from 'antd';
import { Badge } from 'flowbite-react';
import React, { useState } from 'react';
import { Link, useLoaderData, useNavigate } from 'react-router-dom';

const columns = [
  {
    title: 'Number',
    dataIndex: 'number',
    key: 'number',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Source Document',
    dataIndex: 'source_document',
    key: 'source_document',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Customer',
    dataIndex: 'customer',
    key: 'customer',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
  },
  {
    title: 'Total',
    dataIndex: 'total',
    key: 'total',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    render: (_, record) => <span>GHc {record.total}</span>
  },
  {
    title: 'Invoice Status',
    dataIndex: 'invoice_status', 
    key: 'invoice_status',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    render: (_, record) => <Badge className={record.invoice_status === 'Waiting Bills' ? "text-blue-600 bg-blue-100 w-max" : record.invoice_status === 'Fully Paid' ? "text-green-950 bg-green-100 w-max" : record.invoice_status === 'Nothing To Bill' && "text-slate-950 bg-slate-100 w-max"}>{record.invoice_status}</Badge>
  },
  {
    title: 'Effective Date',
    dataIndex: 'effective_date',
    key: 'effective_date',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    render: (_, record) => <span>{new Date(record.effective_date).toLocaleDateString()} {new Date(record.effective_date).toLocaleTimeString()}</span>
  },
  {
    title: 'Action',
    key: 'operation',
    fixed: 'right',
    width: 100,
    className: 'whitespace-nowrap font-medium text-dark-600 dark:text-white',
    render: (_, record) => (
      <Link className='h-full w-full' to={'/sales/orders/'+record.number}>
        EDIT
      </Link>
    )
  }
]



const SalesToInvoice = () => {
  const salesToInvoice = useLoaderData();
  const navigate = useNavigate();

  const onRow = (record, rowIndex) => {
    return {
      onClick: () => navigate('/sales/orders/'+record.number.replaceAll('/', '-'))
    };
  }


  
  return (
    <div>
      <div className='flex justify-between mx-4'>
        <h3 className='font-bold'>Orders To Invoice</h3>
        <div className=' bg-white dark:bg-gray-900'>
          {/* <Input addonBefore={<MdFilterAlt />}  defaultValue="mysite" /> */}

          <Select
            mode='multiple'
            size={'middle'}
            placeholder='Filter'
            // defaultValue={['a10', 'c12']}
            // onChange={handleChange}
            className='w-96'
            options={[]}
          />
        </div>
      </div>
      <div className='flex justify-end mx-4 my-2'>
        {/* <div className=''>
          <Button className='' size={'sm'}>
            <Link to={'/sales/orders/new'} className='w-full'>New</Link>
          </Button>
        </div> */}
        <div className='dark:bg-gray-900'>
          <div className='flex justify-end'>
            <Pagination  total={50} />
          </div>
        </div>
      </div>
      <Table
        sticky
        onRow={onRow}
        rowClassName={'hover:cursor-pointer'}
        dataSource={salesToInvoice}
        columns={columns}
        scroll={{ x: 1500 }}
        pagination={false}
        rowKey={'number'}
      />
    
    </div>
  )
}

export default SalesToInvoice;